import axios from 'axios';
import { getEndpoint, getRequestHeaders  } from './config'

export default function () {
    return new Promise<any>((resolve, reject) => {
        axios
            .get(
                getEndpoint('destinations', null),
                getRequestHeaders(true)
            )
            .then(function (response : any) {
                resolve(response.data.destinations);
            })
            .catch(function (rs : any) {
                reject(rs);
            });
    });
}